import { Controller } from "@hotwired/stimulus"

// Focuses the top bar's search field from the keyboard, and from the mobile
// search glyph. The bar renders a "/" hint, so the shortcut has to actually
// exist — a printed hint for a binding nobody wrote is worse than no hint.
//
// Bound on the <header>, but the listener is on document: the point of a
// shortcut is that it works while focus is anywhere on the page.
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.onKey = this.onKey.bind(this)
    document.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
  }

  focus(event) {
    if (event) event.preventDefault()
    if (!this.hasInputTarget) return
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  onKey(event) {
    // Never steal a keystroke the user meant for something they are typing in.
    const el = document.activeElement
    if (el && (el.isContentEditable ||
               ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName))) return

    const isSlash = event.key === "/" && !event.metaKey && !event.ctrlKey && !event.altKey
    const isCmdK = event.key.toLowerCase() === "k" && (event.metaKey || event.ctrlKey)
    if (isSlash || isCmdK) this.focus(event)
  }
}
